import { render, staticRenderFns } from "./SbolIconOpenCollapseList.vue?vue&type=template&id=19042a02&scoped=true&"
import script from "./SbolIconOpenCollapseList.vue?vue&type=script&lang=js&"
export * from "./SbolIconOpenCollapseList.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "19042a02",
  null
  ,true
)

export default component.exports